/**
 * The `Submit Feedback` permission as a boolean (the `usePermission` pattern, spec A.1). The check is
 * the shared access evaluator, so System Admin and folder grants count; the server enforces the same
 * registry permission on the handler routes.
 */
import { declarations } from '@ic/security-registry';
import { useCanAccess } from '@/hooks/useCanAccess';

export const SUBMIT_FEEDBACK_PERMISSION = declarations.Feedback.reportFeedbackSubmit.permission;

export function useCanSubmitFeedback(): boolean {
  const { canAccess } = useCanAccess();
  return canAccess(SUBMIT_FEEDBACK_PERMISSION);
}
